import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { FunnelStep } from '../../data/analyticsStore';
interface FunnelChartProps {
  data: FunnelStep[];
}
function getBarColor(step: FunnelStep, idx: number, total: number): string {
  if (step.ctr > 0 && step.ctr < 80 && idx > 0) return '#f59e0b';
  if (step.ctr > 0 && step.ctr < 70 && idx > 0) return '#ef4444';
  const t = idx / Math.max(total - 1, 1);
  const r = Math.round(0 + t * 245);
  const g = Math.round(212 - t * 54);
  const b = Math.round(255 - t * 244);
  return `rgb(${r},${g},${b})`;
}
interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: FunnelStep;
  }>;
}
function FunnelTooltip({
  active,
  payload
}: CustomTooltipProps) {
  if (!active || !payload?.[0]) return null;
  const d = payload[0].payload;
  return <div className="rounded-lg border border-white/15 bg-[#0c1222]/95 backdrop-blur-md px-4 py-3 shadow-xl" data-id="element-12">
      <p className="text-sm font-bold text-white mb-1" data-id="element-13">{d.label}</p>
      <p className="text-xs text-white/60" data-id="element-14">
        Count: <span className="text-white font-medium" data-id="element-15">{d.count}</span>
      </p>
      <p className="text-xs text-white/60" data-id="element-16">
        CTR from prev:{' '}
        <span className="text-cyan-400 font-medium" data-id="element-17">{d.ctr.toFixed(1)}%</span>
      </p>
      <p className="text-xs text-white/60" data-id="element-18">
        % of total:{' '}
        <span className="text-amber-400 font-medium" data-id="element-19">
          {d.percentOfTotal.toFixed(1)}%
        </span>
      </p>
    </div>;
}
export function FunnelChart({
  data
}: FunnelChartProps) {
  return <div className="rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-5" style={{
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)'
  }} data-id="element-20">
      <h3 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4" data-id="element-21">
        Funnel Drop-off
      </h3>
      <div className="w-full h-72" data-id="element-22">
        <ResponsiveContainer width="100%" height="100%" data-id="element-23">
          <BarChart data={data} margin={{
          top: 8,
          right: 8,
          bottom: 4,
          left: -12
        }} data-id="element-24">
            <XAxis dataKey="label" tick={{
            fill: 'rgba(255,255,255,0.35)',
            fontSize: 11
          }} axisLine={{
            stroke: 'rgba(255,255,255,0.08)'
          }} tickLine={false} interval={0} angle={-45} textAnchor="end" height={50} data-id="element-25" />
            <YAxis tick={{
            fill: 'rgba(255,255,255,0.3)',
            fontSize: 11
          }} axisLine={false} tickLine={false} data-id="element-26" />
            <Tooltip content={<FunnelTooltip data-id="element-28" />} cursor={{
            fill: 'rgba(255,255,255,0.03)'
          }} data-id="element-27" />
            <Bar dataKey="count" radius={[4, 4, 0, 0]} maxBarSize={40} data-id="element-29">
              {data.map((step, idx) => <Cell key={step.name} fill={getBarColor(step, idx, data.length)} fillOpacity={0.85} data-id="element-30" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>;
}